import { useEffect, useState } from 'react';
import axios from 'axios';
import { API, authHeaders } from '../api/ticketsApi';

/**
 * Fetches role-based ticket menu permissions.
 * Returns allowedPaths (nav path segments without /dashboard/tickets prefix).
 */
export function useTicketPermissions() {
  const [allowedPaths, setAllowedPaths] = useState(null);
  const [ticketRole, setTicketRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    axios
      .get(`${API}/permissions/menu`, authHeaders())
      .then((res) => {
        if (cancelled) return;
        setAllowedPaths(res.data.allowed_nav || res.data.allowedPaths || []);
        setTicketRole(res.data.ticket_role || res.data.role || null);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.response?.data?.detail || 'Failed to load permissions');
        setAllowedPaths(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const canAccess = (path) => {
    if (allowedPaths === null) return true;
    return allowedPaths.includes(path);
  };

  return { allowedPaths, ticketRole, loading, error, canAccess };
}
